var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{staticClass:"stepper split-view fill-height",attrs:{"row":""}},[_c('v-flex',[_c('v-stepper',_vm._b({staticClass:"stepper-content fill-height",attrs:{"value":_vm.value},on:{"change":_vm.update}},'v-stepper',_vm.$props,false),[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }